var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modelType)?_c('div',{staticClass:"channel-tag",class:_vm.modelType}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }